import React from 'react';
import cx from 'classnames';
import { Icon } from 'lmc-ui-library';
import { ITask, TaskStatus, TaskStatuses } from 'modules/cm/Tasks/Task';
import css from './Tasklist.module.scss';

interface TaskProps {
  task: ITask;
}

type TaskAction = (task: ITask) => void;

interface Props extends TaskProps {
  onNotApplicable?: TaskAction;
  onComplete?: TaskAction;
  onUndo?: TaskAction;
  className?: string;
}

interface CompletedTaskProps extends TaskProps {
  onUndo: TaskAction;
}

interface ToDoTaskProps extends TaskProps {
  onComplete: TaskAction;
  onNotApplicable: TaskAction;
}

const canCompleteTask = (status: TaskStatus): boolean => {
  return status === TaskStatuses.TO_DO;
};
const canSetNotApplicableTask = (status: TaskStatus): boolean => {
  return status === TaskStatuses.TO_DO;
};
const canUndo = (status: TaskStatus): boolean => {
  return status === TaskStatuses.COMPLETED || status === TaskStatuses.NOT_APPLICABLE;
};

const Task = ({ task, onComplete, onNotApplicable, onUndo, className }: Props) => {
  const label = task.getLabel();
  const statusLabel = task.getStatusLabel();
  const status = task.getStatus();

  return (
    <div className={cx(css.task, className)}>
      <Icon className={css.icon} type="declarations" color="rgba(45, 53, 64, 0.5)" />
      <span>{label}</span>
      <div className={css.actions}>
        {canSetNotApplicableTask(status) && onNotApplicable && (
          <button className={`${css.action} ${css.notApplicable}`} onClick={onNotApplicable.bind(null, task)}>
            Not applicable
          </button>
        )}
        {canCompleteTask(status) && onComplete && (
          <button className={`${css.action} ${css.complete}`} onClick={onComplete.bind(null, task)}>
            Task complete
          </button>
        )}
        {canUndo(status) && onUndo && (
          <button className={css.action} onClick={onUndo.bind(null, task)}>
            Undo
          </button>
        )}
        {statusLabel && <span className={css.status}>{statusLabel}</span>}
      </div>
    </div>
  );
};

const CompletedTask = ({ task, onUndo }: CompletedTaskProps) => {
  return <Task task={task} onUndo={onUndo} className={cx({ [css.inProgress]: task.isActionInProgress })} />;
};

const ToDoTask = ({ task, onComplete, onNotApplicable }: ToDoTaskProps) => {
  return (
    <Task
      task={task}
      onComplete={onComplete}
      onNotApplicable={onNotApplicable}
      className={cx({ [css.inProgress]: task.isActionInProgress })}
    />
  );
};

export default Task;
export { CompletedTask, ToDoTask };
